export const APP_STARTED = 'APP_STARTED';
export const INITIALIZE_AUTH = 'INITIALIZE_AUTH';
export const SET_TEASE_IFRAME_DIMENSIONS = 'SET_TEASE_IFRAME_DIMENSIONS';
export const SET_FLOATING_IFRAME_DIMENSIONS = 'SET_FLOATING_IFRAME_DIMENSIONS';